import React from "react"
import gql from "graphql-tag"
import { Query } from "react-apollo"
import { Redirect, withRouter } from "react-router"
import UpsellModal from "../../components/UpsellModal"

import "./report.scss"

const GET_INTERACTIVE_REPORT = gql`
  query GetInteractiveReport($slug: String!) {
    getInteractiveReport(slug: $slug) {
      id
      name
      url
    }
  }
`

const InteractiveReport = (props) => {
  const { isUserAuthenticated, roles } = props.viewer

  const hasRole = roles ? roles.includes(props.role) : false

  if (!isUserAuthenticated) {
    return (
      <Redirect
        to={{ pathname: "/login", state: { from: props.location.pathname } }}
      />
    )
  }

  if (!hasRole) {
    return <UpsellModal />
  }

  let slug
  try {
    slug = props.match.params.slug
  } catch (err) {
    slug = ""
  }

  if (slug) {
    return (
      <div className="interactive-report-container">
        <Query
          query={GET_INTERACTIVE_REPORT}
          variables={{ slug }}
          ssr={false}
          fetchPolicy="network-only"
        >
          {({ data, error, loading }) => {
            if (loading) {
              return <div>Loading...</div>
            }
            if (error) {
              return <div>An error occurred retrieving the report.</div>
            }

            if (data && data.getInteractiveReport) {
              return (
                <iframe
                  id={data.getInteractiveReport.slug}
                  src={data.getInteractiveReport.url}
                ></iframe>
              )
            }

            return <Redirect to="/not-found" />
          }}
        </Query>
      </div>
    )
  }
  return null
}

export default withRouter(InteractiveReport)
